import { SimpleTestResult } from "interface/interface.inspect";
import { useNavigate } from "react-router-dom";
import { InspectHomeRecentlyRecordWrapper, NoData } from "style/inspect";
import { getResultImageByType, getReultTypeTitle } from "utils/inspect.util";
import { formatDateTime } from "utils/util";

interface DataProps {
  data: SimpleTestResult[];
}

const InspectHomeRecentlyRecord = ({ data }: DataProps) => {
  const navigate = useNavigate();

  const sortedData = [...data]
    .sort((a, b) => new Date(b.regDt).getTime() - new Date(a.regDt).getTime())
    .slice(0, 5); // 최근 5개만 가져오기
  return (
    <InspectHomeRecentlyRecordWrapper>
      {sortedData && sortedData.length > 0 ? (
        sortedData.map((item, index) => (
          <div
            key={index}
            className="itme-wrapper"
            onClick={() => {
              navigate(`/inspect/simple/result/preview/detail/${item.type}`);
            }}
          >
            <div className="title">
              <p>{formatDateTime(item.regDt)}</p>
              <span>간이 검사</span>
            </div>
            <div className="contents-box">
              <div className="img-box">
                <img src={getResultImageByType(item.type)} alt="측정 결과" />
              </div>
              <div className="result-type">
                <p>나의 층간소음 유형은</p>
                <h4>{getReultTypeTitle(item.type)}</h4>
              </div>
            </div>
          </div>
        ))
      ) : (
        <NoData>
          <p>검사 결과가 없습니다.</p>
        </NoData>
      )}
    </InspectHomeRecentlyRecordWrapper>
  );
};

export default InspectHomeRecentlyRecord;
